import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{attrs:{"rounded":"lg"}},[_c('calendar',{attrs:{"items":_vm.events,"weekday":[1, 2, 3, 4, 5, 6, 0],"scoped-groups":[],"categories":[],"selected-date":_vm.localSelectedDate,"mode":"stack","calendar-day-start-time-minutes":420,"calendar-day-end-time-minutes":1320,"calendar-day-interval-minutes":30},on:{"updateSelectedDate":function($event){_vm.localSelectedDate=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }